"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AdminDocumentTemplateController = /** @class */ (function () {
    function AdminDocumentTemplateController($state, $scope, FlashService, $window, DocumentTemplateModel) {
        this.$state = $state;
        this.$scope = $scope;
        this.FlashService = FlashService;
        this.$window = $window;
        this.DocumentTemplateModel = DocumentTemplateModel;
        this.busy = false;
        // Initialize component state
        this.templates = [];
        this.currentPage = 1;
        this.totalPages = 0;
        this.itemsPerPage = 20;
        this.searchQuery = "";
        this.statusFilter = "";
        this.loadTemplates();
    }
    AdminDocumentTemplateController.prototype.loadTemplates = function (page) {
        var _this = this;
        if (page === void 0) { page = 1; }
        if (this.busy) {
            return;
        }
        this.busy = true;
        var params = {
            page: page,
            per_page: this.itemsPerPage,
        };
        if (this.searchQuery) {
            params.search = this.searchQuery;
        }
        if (this.statusFilter) {
            params.status = this.statusFilter;
        }
        this.DocumentTemplateModel.getTemplates(params)
            .then(function (response) {
            _this.templates = response.data;
            _this.currentPage = response.current_page;
            _this.totalPages = response.last_page;
        })
            .catch(function (error) {
            console.error("Error loading templates:", error);
            _this.FlashService.setMessage({
                type: "error",
                message: "Failed to load document templates",
            });
        })
            .finally(function () {
            _this.busy = false;
        });
    };
    AdminDocumentTemplateController.prototype.createTemplate = function () {
        this.$state.go("drivecoach.admin.documenttemplates.create");
    };
    AdminDocumentTemplateController.prototype.editTemplate = function (template) {
        this.$state.go("drivecoach.admin.documenttemplates.edit", {
            id: template.id,
        });
    };
    AdminDocumentTemplateController.prototype.viewTemplate = function (template) {
        this.$state.go("drivecoach.admin.documenttemplates.view", {
            id: template.id,
        });
    };
    AdminDocumentTemplateController.prototype.deleteTemplate = function (template) {
        var _this = this;
        if (!confirm("Are you sure you want to delete \"".concat(template.name, "\"?"))) {
            return;
        }
        this.DocumentTemplateModel.deleteTemplate(template.id)
            .then(function () {
            _this.FlashService.setMessage({
                type: "success",
                message: "Template deleted successfully",
            });
            _this.loadTemplates(_this.currentPage);
        })
            .catch(function (error) {
            console.error("Error deleting template:", error);
            _this.FlashService.setMessage({
                type: "error",
                message: "Failed to delete template",
            });
        });
    };
    AdminDocumentTemplateController.prototype.onSearch = function () {
        this.loadTemplates(1);
    };
    AdminDocumentTemplateController.prototype.onFilterChange = function () {
        this.loadTemplates(1);
    };
    AdminDocumentTemplateController.prototype.goToPage = function (page) {
        if (page >= 1 && page <= this.totalPages) {
            this.loadTemplates(page);
        }
    };
    AdminDocumentTemplateController.prototype.getStatusClass = function (status) {
        var classes = {
            draft: "label-warning",
            active: "label-success",
            archived: "label-default",
        };
        return classes[status] || "label-default";
    };
    AdminDocumentTemplateController.prototype.formatDate = function (dateString) {
        if (!dateString) {
            return "";
        }
        var date = new Date(dateString);
        return (date.toLocaleDateString() +
            " " +
            date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }));
    };
    AdminDocumentTemplateController.prototype.formatRelativeDate = function (dateString) {
        if (!dateString) {
            return "";
        }
        var date = new Date(dateString);
        var now = new Date();
        var diffMs = now.getTime() - date.getTime();
        var diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
        if (diffDays === 0) {
            return "today";
        }
        if (diffDays === 1) {
            return "yesterday";
        }
        if (diffDays < 7) {
            return "".concat(diffDays, " days ago");
        }
        if (diffDays < 30) {
            var weeks = Math.floor(diffDays / 7);
            return "".concat(weeks, " ").concat(weeks === 1 ? "week" : "weeks", " ago");
        }
        return this.formatDate(dateString);
    };
    return AdminDocumentTemplateController;
}());
AdminDocumentTemplateController.$inject = [
    "$state",
    "$scope",
    "FlashService",
    "$window",
    "DocumentTemplateModel",
];
exports.default = AdminDocumentTemplateController;
